import React, { Fragment, useState } from "react";
import PropTypes from 'prop-types';
import { Col, Row } from "react-bootstrap";
import { Button } from "@mui/material";
import KeyPersonCoverageModal from "./KeyPersonCoverageModal";
import "./SolutionArticleDetail.scss";

export default function SolutionArticleDetail(props) {

  const { items } = props.data;
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Fragment>
      {items.map((item, index) =>
        <Row id={item.anchor} key={index} className={`article-detail-container ${item.backgroundContrast ? "lightBackground" : ""}`}>
          <Col className="w-100">
            <div className="image-container flex-column">
              <img src={item.image} alt="" />
              {item.title === "Key Person Case Study" && (
                <Button
                  variant="contained"
                  color="success"
                  sx={{ mt: 2 }}
                  onClick={() => setModalOpen(true)}
                  className="btn-sm buttonColorLight coverage-button"
                >
                  Calculate Coverage Amount
                </Button>
              )}
            </div>
          </Col>
          <Col className="w-100">
            <Row className="section-content-container">
              <div className="section-content px-0 w-100">
                <h2>{item.title}</h2>
                {item.section.map((section, index) => <div key={index} className="section-group">
                  <h3>{section.title}</h3>
                  {section.paragraphs.map((p, index) => <p key={index}>{p}</p>)}
                </div>)}
              </div>
              <div className="action-container px-0">
                {item.callToAction.map((item, index) =>
                  <Button
                    key={index}
                    variant="contained"
                    href={item.href ? item.href : item.productType === "term" ? props.journeys.termJourney : props.journeys.americoJourney}
                    size="large"
                    className={`btn-sm ${item.buttonLight ? "buttonColorLight" : "buttonColorDark"}`}
                    onClick={undefined}>{item.buttonTitle}</Button>)
                }
              </div>
            </Row>
          </Col>
        </Row>
      )}
      <KeyPersonCoverageModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </Fragment>
  )
}

SolutionArticleDetail.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.array,
  })
}
